import { HasUnsavedChanges, createIonicUnsavedChangesGuard } from './ionic-unsaved-changes.guard';

export type CreateWorkspaceUnsavedChanges = HasUnsavedChanges;

/** Warn before leaving Create Workspace when there are unsaved edits (Ionic alert). */
export const createWorkspaceUnsavedGuard = createIonicUnsavedChangesGuard({
  header: 'Discard changes?',
  message: 'You have unsaved changes on Create Workspace. Leave without saving?',
  stayText: 'Stay',
  discardText: 'Leave',
});
